import React from 'react'
import {ContentType} from 'yougile-util'
import IconAny from './icon-any.svg'
import IconExcel from './icon-excel.svg'
import IconImage from './icon-image.svg'
import IconPdf from './icon-pdf.svg'
import IconSvg from './icon-svg.svg'
import IconText from './icon-text.svg'
import IconVideo from './icon-video.svg'
import IconWord from './icon-word.svg'

const contentTypeIcon: {[key in ContentType]: React.ReactNode} = {
  any: <IconAny />,
  excel: <IconExcel />,
  image: <IconImage />,
  pdf: <IconPdf />,
  svg: <IconSvg />,
  text: <IconText />,
  video: <IconVideo />,
  word: <IconWord />
}

export interface ContentTypeIconProps {
  contentType: ContentType | undefined
}

export const ContentTypeIcon = ({contentType}: ContentTypeIconProps) => (
  <>{contentTypeIcon[contentType || 'any']}</>
)
